import React from 'react'
import { useSelector } from 'react-redux'
import { selectWorkflowType } from '../slices/globalSlice'
import AutoQuestionnaireProcessorForm from './AutoQuestionnaires/Form'
import ManualQuestionnaireProcessorPreviewer from './ManualQuestionnaires/Previewer'

export default function ProcessorForm(props) {
  const workflowType = useSelector(selectWorkflowType)

  if (!workflowType) return null

  if (workflowType === 'automated') {
    return <AutoQuestionnaireProcessorForm {...props} />
  }

  if (workflowType === 'manual') {
    return <ManualQuestionnaireProcessorPreviewer {...props} />
  }
}
